import * as XLSX from 'xlsx';
import $ from "jquery";import {
    useNavigate
  } from "react-router-dom";

const DataReset = () => {
    const navigate = useNavigate();

function sendFileData(profiles){
    $.ajax({
        type:"POST",
        url:"http://localhost:8080/uploadData",
        data:{profiles},
        dataType: 'json',
        xhrFields: {
            withCredentials: true  // Include cookies
          },
          crossDomain: true, 
            success : function(response){
                if(response.message  && response.message.includes("Error in auth")){
                    navigate("/login");
                  }
        //   return  setDataArr(response);
            
        },
        error: function(err){
            console.log("error")
            console.log(err)
        }
    })
}

function UploadProcess() {
        //Reference the FileUpload element.
        var fileUpload = document.getElementById("fileUpload");
    
        //Validate whether File is valid Excel file.
        var regex = /^([a-zA-Z0-9\s_\\.\-:])+(.xls|.xlsx)$/;
        if (regex.test(fileUpload.value.toLowerCase())) {
            if (typeof (FileReader) != "undefined") {
                var reader = new FileReader();
    
                //For Browsers other than IE.
                if (reader.readAsBinaryString) {
                    reader.onload = function (e) {
                        GetTableFromExcel(e.target.result);
                    };
                    reader.readAsBinaryString(fileUpload.files[0]);
                } else {
                    //For IE Browser.
                    reader.onload = function (e) {
                        var data = "";
                        var bytes = new Uint8Array(e.target.result);
                        for (var i = 0; i < bytes.byteLength; i++) {
                            data += String.fromCharCode(bytes[i]);
                        }
                        GetTableFromExcel(data);
                    };
                    reader.readAsArrayBuffer(fileUpload.files[0]);
                }
            } else {
                alert("This browser does not support HTML5.");
            }
        } else {
            alert("Please upload a valid Excel file.");
        }
};    


function GetTableFromExcel(data) {
    //Read the Excel File data in binary
    var workbook = XLSX.read(data, {
        type: 'binary'
    });

    //get the name of First Sheet.
    var Sheet = workbook.SheetNames[0];

    //Read all rows from First Sheet into an JSON array.
    var excelRows = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[Sheet]);

    var json_object = JSON.stringify(excelRows);

    var parsed = JSON.parse(json_object);
    console.log(parsed)

    var profiles =[];
    var hofs =[];
    var finalhofs =[];

    parsed.map((object)=>{
        profiles.push({
            sabeel:object.Sabeel_Number,
            hof:object.ITS_ID,
            name:object.FullName,
            members:object.Members_count,
            block:object.Block
        })
    })
    console.log(profiles)
    // sendFileData(profiles);
};


    const design = (<>
    <input type="file" id="fileUpload" />
    <input type="button" id="upload" value="Upload" onClick={UploadProcess} />
    </>);
    return design;
}

export default DataReset;